<template>
  <div id="app">
    <Header class="header"></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  .header{
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index:9999
  }

  /* 在全局CSS里引用: */
  /* 滚动条宽度 */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  /* 滚动条的滑块 */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(188, 190, 196, 0.73);
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue